module.exports = __webpack_public_path__ + "static/media/uk_flag.4c07e613.svg";